import React, { useEffect, useState, useCallback } from 'react';
import { Grid } from 'semantic-ui-react';

import EnvironmentalInformationSelectInputsComponent from './IEnvironmentalInformationAllSelectInputs';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import EnvironmentalRisk from './EnvironmentalRisk';
import { conditionToDisplayEnvInfoAndEnvRiskLevel } from '../../../../utils';
import { connect } from 'react-redux';
import { risksActions } from '../../../../behavior/risks';
import { locationsActions } from '../../../../behavior/locations';

type Props = {
  values: any;
  watershedId: number;
  initialData: any;
  errors: any;
  getWatershedIdByLocation: (id: number) => void;
  clearEnvRiskCalculationDto: () => void;
  setValues: (arg: any) => void;
  envRiskCalculationAction: () => void;
  disabled: boolean;
  setFieldValue: (arg1: string, arg2: string | null) => void;
};

const IEnvironmentalInformationContainer = ({
  values,
  watershedId,
  initialData,
  errors,
  getWatershedIdByLocation,
  clearEnvRiskCalculationDto,
  setValues,
  envRiskCalculationAction,
  setFieldValue,
  disabled,
}: Props) => {
  const [initialEnvAttr, setInitialEnvAttr] = useState(
    values.envAttributes || initialData.envAttributes
  );
  const [conditionToDisplayEnv, setConditionToDisplayEnv] = useState(
    conditionToDisplayEnvInfoAndEnvRiskLevel(values)
  );

  useEffect(() => {
    const newConditionToDisplayEnv = conditionToDisplayEnvInfoAndEnvRiskLevel(values);

    if (conditionToDisplayEnv !== newConditionToDisplayEnv) {
      setConditionToDisplayEnv(newConditionToDisplayEnv);
      clearEnvRiskCalculationDto();
    }

    if (newConditionToDisplayEnv && values.envAttributes == null) {
      values.envAttributes = initialEnvAttr;
      setValues(values);

      if (
        values.location &&
        (!values.envAttributes.waterCourse || !values.envAttributes.waterCourse.id)
      ) {
        getWatershedIdByLocation(values.location.id);
      }
    } else if (!newConditionToDisplayEnv && values.envAttributes != null) {
      setInitialEnvAttr(values.envAttributes);
      values.envAttributes = null;
    }
  }, [values, watershedId, errors, initialEnvAttr, conditionToDisplayEnv]);

  useEffect(() => {
    const waterCourse = initialData.riskWatershedList.find(
      (r: any) => (r.watershed && r.watershed.id === watershedId) || (!r.watershed && !watershedId)
    );

    setInitialEnvAttr((prev: any) => ({
      ...prev,
      waterCourse: Object.assign({}, waterCourse),
    }));

    if (conditionToDisplayEnv) {
      values.envAttributes.waterCourse = Object.assign({}, waterCourse);

      if (waterCourse && errors?.envAttributes?.waterCourse) {
        errors.envAttributes.waterCourse = {};
      }
      envRiskCalculationAction();
    }
  }, [watershedId]);

  const getEnvironmentalInformationContainerContent = () => {
    const envAttributesPropName = 'envAttributes';
    if (!values[envAttributesPropName]) {
      values[envAttributesPropName] = {};
    }

    return (
      <Grid stackable doubling columns={4} verticalAlign="bottom">
        <EnvironmentalInformationSelectInputsComponent
          values={values}
          initialData={initialData}
          disabled={disabled}
          setFieldValue={setFieldValue}
        />
      </Grid>
    );
  };

  if (conditionToDisplayEnv) {
    const initialEnvRiskResultDto = {
      envRisk: values.envRisk,
      envRiskLevel: values.envRiskLevel,
    };

    return (
      <>
        <AccordionWrapper
          collapsed={false}
          accordionTitle="inventory.details.page.environmental.inf.container.title"
          titleAddition={
            <EnvironmentalRisk
              initialEnvRiskResultDto={initialEnvRiskResultDto}
              conditionToDisplayEnvRiskLevel={conditionToDisplayEnv}
              values={values}
            />
          }
          className="containerReducedWhiteSpace"
          render={getEnvironmentalInformationContainerContent}
        />
      </>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state: any) => ({
  envRiskCalculation: state.risks.envRiskCalculation,
  watershedId: state.locations.watershedId,
});

const mapDispatchToProps = (dispatch: any) => ({
  clearEnvRiskCalculationDto: () => dispatch(risksActions.clearEnvRiskCalculationDto()),
  getWatershedIdByLocation: (id: number) => dispatch(locationsActions.getWatershedIdByLocation(id)),
  envRiskCalculationAction: () => dispatch(risksActions.envRiskCalculation()),
});

export default connect(mapStateToProps, mapDispatchToProps)(IEnvironmentalInformationContainer);
